import { Component, HostListener, OnInit, NgModule, ViewChild } from '@angular/core';
import { MatRipple } from '@angular/material/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { CouponModel } from 'src/app/models/coupon-model';
import { ItemDisplayData } from 'src/app/models/item-display-data';
import { CouponsService } from 'src/app/services/coupons.service';
import { CurrentInfoService } from 'src/app/services/current-info.service';
import { CurrentOrderService } from 'src/app/services/current-order.service';
import { CustomerService } from 'src/app/services/customer.service';
import { InitializationService } from 'src/app/services/initialization.service';
import { LocaleService } from 'src/app/services/locale.service';
import { NavigationService } from 'src/app/services/navigation.service';
import { AnalyticsService } from 'src/app/services/analytics.service';
import { WorkWeekService } from 'src/app/services/work-week.service';
import { ActionDialogComponent } from '../dialogs/action-dialog/action-dialog.component';
import { AlertDialogComponent } from '../dialogs/alert-dialog/alert-dialog.component';
import { PickCouponDialogComponent } from '../dialogs/pick-coupon-dialog/pick-coupon-dialog.component';

@Component({
  selector: 'app-current-order',
  templateUrl: './current-order.component.html',
  styleUrls: ['./current-order.component.scss']
})
export class CurrentOrderComponent implements OnInit 
{
  @ViewChild('couponbar', { read: MatRipple })
  couponripple?: MatRipple;

  @ViewChild('floorbar', { read: MatRipple })
  floorripple?: MatRipple;

  @HostListener('window:beforeunload', ['$event'])
  unloadNotification($event: any) 
  {
    if (this.hasItem === true) 
        $event.returnValue =true;
  }

  currentPriceString:string = '';
  itemList:Array<ItemDisplayData> = new Array<ItemDisplayData>();
  hasItem:boolean = false;
  hasFee:boolean = false;
  feeString:string = '';
  showFloorMessage:boolean = false;
  floorMessage:string = '';
  showCouponMessage:boolean = false;
  couponMessage:string = 'Cupom';
  canSend:boolean = true;
  rippleColor:string = "#FFFFFF25";
  showCouponIcon:boolean=false;
  couponCount:number = 0;
  coupon:CouponModel | undefined;

  constructor
  (
    private initializationservice:InitializationService, 
    private currentorderservice:CurrentOrderService,
    private navigationservice:NavigationService,
    private route: ActivatedRoute,
    private router:Router,
    private customerservice:CustomerService,
    private workweekservice:WorkWeekService,
    public alertDialog: MatDialog,
    private currentinfoservice: CurrentInfoService,
    private localeservice: LocaleService,
    private pixelservice: AnalyticsService,
    private couponservice: CouponsService
  ) { }

  ngOnInit(): void 
  {
    var appname = String(this.route.snapshot.paramMap.get('appname'));

    if(!this.initializationservice.checkApp(appname))
    {
      this.initializationservice.reloadApp(appname);

      return;
    }

    this.currentorderservice.clearAdress();

    this.currentorderservice.checkFee();

    this.update();
  }

  update()
  {
    this.currentorderservice.updateCoupon()
    
    this.currentPriceString = this.currentorderservice.getCurrentPriceString(true, true);
    this.itemList = this.currentorderservice.getOrderItensDisplayData();
    this.hasItem = this.currentorderservice.getOrderItemCount() > 0;

    if(this.hasItem === false)
    {
      this.back();

      return;
    }

    if(this.currentorderservice.getOrderType() === 2)
    {
      this.hasFee = this.currentorderservice.hasFee();

      if(this.hasFee === true)
        this.feeString = this.currentorderservice.getFeeString();

      if(this.currentinfoservice.hasFloor() === true && this.currentorderservice.isAboveFloor() !== true)
      {
        this.floorMessage = String(this.localeservice.instantTranslation("Pages.CurrentOrder.FloorMessageStop")).replace("xXItemValueXx", this.currentinfoservice.getFloorValueString());

        this.canSend = false;

        this.showFloorMessage = true;

        setTimeout(() => this.fireFloorRipple(), 300);
      }
      else
        this.showFloorMessage = false;
    }

    this.checkCoupons();
  }

  checkCoupons()
  {
    var orderValue = this.currentorderservice.getCurrentPrice(false,false);

    var visibleCoupons = this.couponservice.getCoupons(orderValue);
    var usableCoupons = visibleCoupons.filter(x => x.Used === false);
    var availableCoupons = usableCoupons.filter(x => x.Available === true);

    this.showCouponIcon = visibleCoupons.length > 0;
    this.couponCount = usableCoupons.length;

    this.coupon = this.currentorderservice.getCoupon();

    if(this.coupon && this.coupon.FloorValue > orderValue)
    {
      this.currentorderservice.clearCoupon();
      
      this.update();

      this.alertDialog.open(AlertDialogComponent, 
      {
        height: 'fit-content',
        width: 'fit-content',
        data: 
        { 
          title:this.localeservice.instantTranslation("Dialogs.Alert.CouponRemoved.Title"), 
          detail:this.localeservice.instantTranslation("Dialogs.Alert.CouponRemoved.Detail"), 
          accept: this.localeservice.instantTranslation("Dialogs.Alert.CouponRemoved.Accept")
        }
      });

      return;
    }

    if(this.showFloorMessage === true || this.coupon)
      return;

    if(availableCoupons.length > 0)
    {
      var floorRejectedCoupons = availableCoupons.filter(x => x.FloorRejected === true);
      var appliableCoupons = availableCoupons.filter(x => x.FloorRejected === false);

      if(appliableCoupons.length > 0)
      {
        this.couponMessage = this.localeservice.instantTranslation("Pages.CurrentOrder.CouponMessage");

        this.showCouponMessage = true;
      }
      else if(floorRejectedCoupons.length > 0)
      {
        var ordered = floorRejectedCoupons.sort((a,b) => a.OrderFloorValue - b.OrderFloorValue)

        var coupon = ordered[0];

        this.couponMessage = String(this.localeservice.instantTranslation("Pages.CurrentOrder.AlmostCouponMessage")).replace('xvaluex', this.localeservice.getCurrencyString(coupon.OrderFloorValue - orderValue)).replace('xdiscountx', coupon.ValueString.replace('-', ''));

        this.showCouponMessage = true;
      }
    }
  }

  couponClick()
  {
    if(this.coupon)
    {
      var dialRef = this.alertDialog.open(AlertDialogComponent, 
      {
        height: 'fit-content',
        width: 'fit-content',
        data: 
        { 
          title:this.localeservice.instantTranslation("Dialogs.Alert.RemoveWarning.Title"), 
          detail:String(this.localeservice.instantTranslation("Dialogs.Alert.RemoveWarning.Detail")).replace('xXx', this.coupon.Name), 
          accept: this.localeservice.instantTranslation("Dialogs.Alert.RemoveWarning.Accept"), 
          cancel:this.localeservice.instantTranslation("Dialogs.Alert.RemoveWarning.Cancel")
        }
      });
      
      dialRef.afterClosed().subscribe(result =>
      {
        if(result === true)
        {
          this.currentorderservice.clearCoupon();

          this.update();
        }
      });
    }
  }

  back()
  {
    this.navigationservice.back();
  }

  itemClick(item:any)
  {
    if(item.ID !== undefined)
    {
      var edit = this.localeservice.instantTranslation("Dialogs.Action.CurrentOrder.Edit");
      var remove = this.localeservice.instantTranslation("Dialogs.Action.CurrentOrder.Remove");

      var dialRef = this.alertDialog.open(ActionDialogComponent, 
        {
          height: 'fit-content',
          width: '60vw',
          data: 
          { 
            title:this.localeservice.instantTranslation("Dialogs.Action.CurrentOrder.Title"), 
            detail:this.localeservice.instantTranslation("Dialogs.Action.CurrentOrder.Detail"), 
            itens: [edit, remove], 
            cancel:this.localeservice.instantTranslation("Dialogs.Action.CurrentOrder.Cancel") }
        });

        dialRef.afterClosed().subscribe(result =>
          {
            if(result === edit)
            {
              var appname = String(this.route.snapshot.paramMap.get('appname'));

              if(item.Type === 'item')
                this.router.navigateByUrl('/' + appname + '/menuitem/'+ item.ID  + '?status=edit');

              if(item.Type === 'combo')
                this.router.navigateByUrl('/' + appname + '/combo/'+ item.ID  + '?status=edit');
            }
            
            if(result === remove)
            {
              var dialRef = this.alertDialog.open(AlertDialogComponent, 
              {
                height: 'fit-content',
                width: 'fit-content',
                data: 
                { 
                  title:this.localeservice.instantTranslation("Dialogs.Alert.RemoveWarning.Title"), 
                  detail:String(this.localeservice.instantTranslation("Dialogs.Alert.RemoveWarning.Detail")).replace('xXx', item.Name), 
                  accept: this.localeservice.instantTranslation("Dialogs.Alert.RemoveWarning.Accept"), 
                  cancel:this.localeservice.instantTranslation("Dialogs.Alert.RemoveWarning.Cancel")
                }
              });
              
              dialRef.afterClosed().subscribe(result =>
              {
                if(result === true)
                {
                  var removed = false;

                  if(item.Type === 'item')
                    removed = this.currentorderservice.removeItem(item.ID);

                  if(item.Type === 'combo')
                    removed = this.currentorderservice.removeCombo(item.ID);

                  if(removed === true)
                  {
                    this.pixelservice.facebookTrack('RemovedFromOrder', { name: item.Name, id: item.UniversalID } );

                    this.update();
                  }
                }
              });
            }
          });
     
    }
  }
 
  finishOrder()
  {
    if(!this.currentinfoservice.isOpen())
    {
      this.alertDialog.open(AlertDialogComponent, 
      {
        height: 'fit-content',
        width: 'fit-content',
        data: 
        { 
          title:this.localeservice.instantTranslation("Dialogs.Alert.ClosedWarning.Title"), 
          detail:this.currentinfoservice.getClosedMessage(), 
          accept:this.localeservice.instantTranslation("Dialogs.Alert.ClosedWarning.Accept")
        }
      });
      
      return;
    }

    if(!this.workweekservice.isOpen())
    {
      this.alertDialog.open(AlertDialogComponent, 
      {
        height: 'fit-content',
        width: 'fit-content',
        data: 
        { 
          title:this.localeservice.instantTranslation("Dialogs.Alert.ClosedWarning.Title"), 
          detail:this.localeservice.instantTranslation("Dialogs.Alert.ClosedWarning.Detail"), 
          accept:this.localeservice.instantTranslation("Dialogs.Alert.ClosedWarning.Accept")
        }
      });
      
      return;
    }

    var appname = String(this.route.snapshot.paramMap.get('appname'));

    if(!this.customerservice.hasCustomerData())
    {
      this.router.navigateByUrl('/' + appname + '/editprofile?afterto=finishorder');

      return;
    }

    var orderType = this.currentorderservice.getOrderType();

    switch (orderType) 
    {
      case 0:
        this.router.navigateByUrl('/' + appname + '/paycard');
        break;
      case 1:
        this.router.navigateByUrl('/' + appname + '/orderbasedata');
        break;
      case 2:
        var customerAdressList = this.customerservice.getCustomerAdressList();

        if(customerAdressList.length === 0)
          this.router.navigateByUrl('/' + appname + '/addresssearch?afterto=orderbasedata');

        if(customerAdressList.length === 1)
        {
          this.currentorderservice.setAdress(customerAdressList[0]);

          this.router.navigateByUrl('/' + appname + '/orderbasedata');
        }

        if(customerAdressList.length > 1)
          this.router.navigateByUrl('/' + appname + '/adresspicker?origin=order');
        break;
      case 3:
        this.router.navigateByUrl('/' + appname + '/orderbasedata');
        break;
      case 4:
        this.router.navigateByUrl('/' + appname + '/cardescription');
        break;
    
      default:
        break;
    }
  }

  seeCoupons()
  {
    var dialogRef = this.alertDialog.open(PickCouponDialogComponent, 
    {
      height: 'fit-content',
      width: '100vw'
    });

    dialogRef.afterClosed().subscribe((r) =>
    {
      if(r === 'done')
        this.update();
    })
  }

  fireCouponRipple()
  {
    if(this.couponripple)
      this.couponripple.launch({ centered:true });
  }

  fireFloorRipple()
  {
    if(this.floorripple)
      this.floorripple.launch({ centered:true });
  }
}
